import { render, staticRenderFns } from "./ExitItem.vue?vue&type=template&id=aff84f70&scoped=true&"
import script from "./ExitItem.vue?vue&type=script&lang=js&"
export * from "./ExitItem.vue?vue&type=script&lang=js&"
import style0 from "./ExitItem.vue?vue&type=style&index=0&id=aff84f70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff84f70",
  null
  
)

export default component.exports